import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Center, Text, Title } from "@mantine/core";

const Unauthorized: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const from = (location.state as any)?.from;

    return (
        <Center style={{ flexDirection: "column", padding: 32 }}>
            <Title order={2}>Ingen adgang</Title>
            <Text mt="sm">
                Du har ikke rettigheder til at se denne side{from ? `: ${from}` : ""}.
            </Text>
            <Button mt="lg" onClick={() => navigate("/")}>
                Gå til forsiden
            </Button>
        </Center>
    );
};

export default Unauthorized;
